import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { CursusThumbnail } from "../../components/thumbnail/cursusThumbnail";
import { EtudiantThumbnail } from "../../components/thumbnail/etudiantThumbnail";
import { LangueThumbnail } from "../../components/thumbnail/langueThumbnail";
import { ListeLibelleThumbnail } from "../../components/thumbnail/listeLibelleThumbnail";
import { ListeLibelleThumbnailCompetence } from "../../components/thumbnail/ListeLibelleThumbnailCompetence";
import { PresentationThumbnail } from "../../components/thumbnail/presentationThumbnail";
import { Button } from "primereact/button";
import { useAuthState } from "../../context/context";
import UserService from "../../services/userService";
import './vueCandidat.css';
import { Card } from "primereact/card";
import { Listelibelle } from "../../components/list/listeLibelle";
import { enumTypeCompetence } from "../../enums/enumTypeCompetence";
import { Helmet } from "react-helmet";
import { ContactEtudiantDialog } from "../../components/dialog/contactEtudiantDialog";
import RoleHelper from "../../utils/roleHelper";
import FormationService from "../../services/formationService";
import { EntrepriseOffreBreadCrumb } from "../../components/breadCrumb/EntrepriseOffreBreadCrumb";
import { EntrepriseProfilBreadCrumb } from "../../components/breadCrumb/EntrepriseProfilBreadCrumb";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ProjetOverlayPanel } from "../../components/overlayPanel/projetOverlayPanel";
import { LikeEtudiant } from "../../components/like/likeEtudiant";
import { Tooltip } from "primereact/tooltip";
import { OverlayPanel } from "primereact/overlaypanel";
import { Dialog } from "primereact/dialog";
import { BsInfoCircleFill } from "react-icons/bs";
import { DisplayProfileImage } from "../../components/image/displayProfileImage";
import { IoCarOutline, IoCalendarOutline, IoSchoolOutline } from "react-icons/io5";
import Helper from "../../utils/helper";
import { Tag } from "primereact/tag";
import { enumPaireContrat } from "../../enums/enumPaireContrat";
import { Avatar } from "primereact/avatar";
import { UpgradeSubscriptionDialog } from "../../components/dialog/upgradeSubscriptionDialog";
import DocumentService from "../../services/documentService";
import EntrepriseService from "../../services/entrepriseService";
import { handleDocumentDownload } from "../../utils/handleDocumentDownload";
import { useCreditsContext } from "../../context/CreditsContext";
import { enumCreditableShareEntreprise } from "../../enums/enumCreditableShareEntreprise";
import { MissingCreditsDialog } from "../../components/dialog/missingCreditsDialog";

export const VueCandidat = (props) => {

    const { t } = useTranslation();
    const currentUser = useAuthState();
    const [etudiant, setEtudiant] = useState(null);
    const [entreprise, setEntreprise] = useState(null);
    const [loading, setLoading] = useState(true);
    const [loadingComptence, setLoadingCompetence] = useState(true);
    const [loadingEntreprise, setLoadingEntreprise] = useState(true)
    const [refreshToken, setRefreshToken] = useState(null);
    const [listeAppellations, setListeAppellations] = useState([])
    const [listeSavoir, setListeSavoir] = useState([])
    const [listeSavoirFaire, setListeSavoirFaire] = useState([])
    const [compteurSavoir, setCompteurSavoir] = useState(0)
    const [compteurSavoirFaire, setCompteurSavoirFaire] = useState(0)
    const [displayFakeInformation, setDisplayFakeInformation] = useState(true);
    const [displayIsDisabledStudent, setDisplayIsDisabledStudent] = useState(false);  // temporarily disabled
    const [jobsExpanded, setJobsExpanded] = useState(false);
    const toast = useRef(null);
    const jobsContentRef = useRef(null);
    const lieuxPanel = useRef(null);
    const history = useHistory();
    const adminImpersonatingRecruteurId = history.location?.state?.adminImpersonatingRecruteurId

    const userService = new UserService();
    const formationService = new FormationService();
    const candidatUrl = props.match.params.candidatUrl;
    const documentService = new DocumentService();
    const entrepriseService = new EntrepriseService();
    const { refreshCredits, creditsInfo } = useCreditsContext();
    const [dialogConnection, setDialogConnection] = useState(false);
    const [dialogFreemiumInfo, setDialogFreemiumInfo] = useState(false);
    const [showMissingCreditsPopup, setShowMissingCreditsPopup] = useState(false);

    useEffect(() => {
        if (RoleHelper.isAdminImpersonatingEntreprise(currentUser, history.location.pathname)) {
            const storedState = sessionStorage.getItem('myState');
            const state = storedState ? JSON.parse(storedState) : null;
            if (state && state.adminImpersonatingRecruteurId) {
                history.replace(history.location.pathname, { ...history.location.state, adminImpersonatingRecruteurId: state.adminImpersonatingRecruteurId });
            }
            // on supprime le state de la session storage
            sessionStorage.removeItem('myState');
        }
        setLoading(true);
        if(adminImpersonatingRecruteurId){
            userService.getEntreprise(adminImpersonatingRecruteurId)
            .then(_recruteur => {
                if (!_recruteur.recruteurEntreprises[0].entreprise.abonnementEntreprise.isFree) {
                    setDisplayFakeInformation(false);
                }
                setEntreprise(_recruteur);
                setLoadingEntreprise(false);
            })
            .catch(err => {
                setEntreprise(null);
                toast.current.show({ severity: 'error', summary: t('general.failed'), detail: t('general.loading_failed'), life: 3000 });
            })
        }
        else if (RoleHelper.isEntreprise(currentUser)) {
            userService.getEntreprise(currentUser.user.id)
                .then(_recruteur => {
                    if (!_recruteur.recruteurEntreprises[0].entreprise.abonnementEntreprise.isFree) {
                        setDisplayFakeInformation(false);
                    }
                    setEntreprise(_recruteur);
                    setLoadingEntreprise(false);
                })
                .catch(err => {
                    setEntreprise(null);
                    toast.current.show({ severity: 'error', summary: t('general.failed'), detail: t('general.loading_failed'), life: 3000 });
                })
        }
        userService.getCandidat(candidatUrl)
            .then(_candidat => {
                setEtudiant(_candidat);
                setListeAppellations(_candidat.etudiantAppellations.map(appellation => { return appellation.appellation.libelle }));
                // setListeSavoir(_candidat.etudiantCompetences.filter(ec => { return ec.competence.typeCompetence == enumTypeCompetence.SAVOIR }).map(ec => { return ec.competence.libelle }));
                // setListeSavoirFaire(_candidat.etudiantCompetences.filter(ec => { return ec.competence.typeCompetence == enumTypeCompetence.SAVOIRFAIRE }).map(ec => { return ec.competence.libelle }));
                loadFormationCompetence(_candidat);
                // if ((RoleHelper.isEntreprise(currentUser) || RoleHelper.isAdminImpersonatingEntreprise(currentUser, history.location.pathname)) && _candidat.isDisabled) {
                //     setDisplayIsDisabledStudent(true);
                // }
            })
            .catch(err => {
                setEtudiant(null);
                toast.current.show({ severity: 'error', summary: t('general.failed'), detail: t('general.loading_failed'), life: 3000 });
            })
            .finally(() => {
                setLoading(false);
            });
    }, [refreshToken])

    const loadFormationCompetence = (_candidat) => {
        formationService.getAllowedFormationsCompetencesEtudiant(_candidat.id)
            .then((_formationCompetence) => {

                let _listeSavoir = [];
                let _listeSavoirFaire = [];

                // Savoir/Savoir faire : tableau multidimensionnel. Chaque formation a son tableau de savoir/savoir faire
                // _formationCompetence.map((formationCompetence) => {
                //     let _tmpSavoir = [];
                //     let _tmpSavoirFaire = [];
                //     formationCompetence.competenceFormation.map((competence) => {
                //         // on récupère les compétences de la formation si elle sont présente dans les compétences de l'étudiant et si elle sont prit en compte
                //         if(_candidat.etudiantCompetences.some(o => o.competenceId === competence.competenceId && o.prisEnCompte == true)) {
                //             if(competence.competence.typeCompetence == enumTypeCompetence.SAVOIR) {
                //                 _tmpSavoir.push(competence.competence.libelle);
                //             } else if(competence.competence.typeCompetence == enumTypeCompetence.SAVOIRFAIRE) {
                //                 _tmpSavoirFaire.push(competence.competence.libelle);
                //             }
                //         }
                //     });
                //     _listeSavoir.push(_tmpSavoir);
                //     _listeSavoirFaire.push(_tmpSavoirFaire);
                // });

                // Savoir/Savoir faire : tableau à 1 dimension. Toutes les formations sont dans le même tableau
                let _compteurSavoir = [];
                let _compteurSavoirFaire = [];

                _formationCompetence.map((formationCompetence) => {
                    // trier les compétences en fonction de l'ordre de la formation
                    formationCompetence.competenceFormation.sort((a, b) => (a.ordre > b.ordre) ? 1 : -1);

                    let _tmpCompteurSavoir = 0;
                    let _tmpCompteurSavoirFaire = 0;
                    formationCompetence.competenceFormation.map((competence) => {
                        // on récupère les compétences de la formation si elle sont présente dans les compétences de l'étudiant et si elle sont prit en compte
                        if (_candidat.etudiantCompetences.some(o => o.competenceId === competence.competenceId && o.prisEnCompte == true)) {
                            if (competence.competence.typeCompetence == enumTypeCompetence.SAVOIR) {
                                _listeSavoir.push(competence.competence.libelle);
                                // on incrémente le compteur de savoir temporaire
                                _tmpCompteurSavoir++;
                            } else if (competence.competence.typeCompetence == enumTypeCompetence.SAVOIRFAIRE) {
                                _listeSavoirFaire.push(competence.competence.libelle);
                                // on incrémente le compteur de savoir faire temporaire
                                _tmpCompteurSavoirFaire++;
                            }
                        }
                    });
                    // on incrémente le compteur de savoir et savoir faire
                    _compteurSavoir.push(_tmpCompteurSavoir);
                    _compteurSavoirFaire.push(_tmpCompteurSavoirFaire);
                });
                // on filtre les doublons
                _listeSavoir = _listeSavoir.filter((item, index) => _listeSavoir.indexOf(item) === index);
                _listeSavoirFaire = _listeSavoirFaire.filter((item, index) => _listeSavoirFaire.indexOf(item) === index);

                setListeSavoir(_listeSavoir);
                setListeSavoirFaire(_listeSavoirFaire);
                setCompteurSavoir(_compteurSavoir);
                setCompteurSavoirFaire(_compteurSavoirFaire);
            })
            .catch(err => {
                setEtudiant(null);
                toast.current.show({ severity: 'error', summary: t('general.failed'), detail: t('general.loading_failed'), life: 3000 });
            })
            .finally(() => {
                setLoadingCompetence(false);
            });
    }

    const copyUrlLink = () => {
        navigator.clipboard.writeText(window.location.href);
        toast.current.show({ severity: 'success', summary: t('profile.share_profile_success'), life: 3000 });
    }

    const showCVPdf = () => {
        if (!etudiant?.fichierCvPdf) return;
        handleDocumentDownload({
            currentUser,
            setDialogConnection,
            setDialogFreemiumInfo,
            displayFakeInformation,
            entrepriseId: entreprise?.recruteurEntreprises?.[0]?.entrepriseId,
            etudiantId: etudiant.id,
            creditActionEnum: enumCreditableShareEntreprise.CVPAGECANDIDAT,
            documentId: etudiant.fichierCvPdf.id,
            documentName: etudiant.fichierCvPdf.name,
            documentService,
            entrepriseService,
            toast: toast.current,
            t,
            onMissingCredits: () => setShowMissingCreditsPopup(true),
            onCreditUpdate: () => refreshCredits(),
            openMethod: "tab"
        });
    };

    const showPortfolio = () => {
        if (!etudiant?.fichierPortfolio) return;
        handleDocumentDownload({
            currentUser,
            setDialogConnection,
            setDialogFreemiumInfo,
            displayFakeInformation,
            entrepriseId: entreprise?.recruteurEntreprises?.[0]?.entrepriseId,
            etudiantId: etudiant.id,
            creditActionEnum: enumCreditableShareEntreprise.PORTFOLIOPAGECANDIDAT,
            documentId: etudiant.fichierPortfolio.id,
            documentName: etudiant.fichierPortfolio.name,
            documentService,
            entrepriseService,
            toast: toast.current,
            t,
            onMissingCredits: () => setShowMissingCreditsPopup(true),
            onCreditUpdate: () => refreshCredits(),
            openMethod: "tab"
        });
    };

    const handleJobsToggle = () => {
        if (jobsExpanded && jobsContentRef.current) {
            // Si on ferme la liste, on scroll vers le haut
            jobsContentRef.current.scrollTop = 0;
        }
        setJobsExpanded(!jobsExpanded);
    }

    const renderMobilite = () => {
        let _countLieux = 0;
        let _currentLocation;
        let _locations = [];
        if (etudiant.mobiliteInternationale) {
            _countLieux = _countLieux + 1;
            _currentLocation = t('geography.international_except_france')
            _locations.push(_currentLocation);
        }
        if (etudiant.mobiliteFrancaise) {
            _countLieux = _countLieux + 1
            _currentLocation = t('geography.france');
            _locations.push(_currentLocation);
        }
        etudiant.mobiliteRegion?.forEach(r => {
            _countLieux = _countLieux + 1
            _currentLocation = r.libelle
            _locations.push(_currentLocation);
        });
        etudiant.mobiliteDepartement?.forEach(d => {
            _countLieux = _countLieux + 1
            _currentLocation = d.code + " - " + d.libelle
            _locations.push(_currentLocation);
        });
        if (_countLieux > 1) {
            return (
                <>
                    <Button type="button" className="location-button" icon="pi pi-eye" label={`${_countLieux} lieux`} onClick={(e) => lieuxPanel.current.toggle(e)} />
                    <OverlayPanel className="location-panel" ref={lieuxPanel}>
                        {_locations.map((l, indexL) => (
                            <div key={`${l}~${indexL}`}>
                                <div>{l}</div>
                            </div>
                        ))}
                    </OverlayPanel>
                </>
            );
        }
        else if (_countLieux == 1) {
            return <span>{_currentLocation}</span>;
        }
        else return <span>{t('general.not_specified')}</span>;
    }

    const renderTypeRecherche = () => {
        let hasAlternanceTag = false;
        let hasEmploiTag = false;
        let hasStageTag = false;
        
        etudiant?.paireContrats?.forEach(e => {
            if (e.code == enumPaireContrat.ALTCA || e.code == enumPaireContrat.ALTCP) {
                hasAlternanceTag = true;
            }
            if (e.code == enumPaireContrat.CDD || e.code == enumPaireContrat.CDI || e.code == enumPaireContrat.CDIINTERIM || e.code == enumPaireContrat.MISINTERIM || e.code == enumPaireContrat.PROCOM || e.code == enumPaireContrat.PROLIB) {
                hasEmploiTag = true;
            }
            if (e.code == enumPaireContrat.STA) {
                hasStageTag = true;
            }
        });

        return (
            <div className="vue-candidat-search-tags">
                {hasAlternanceTag && <Tag className="tag-alternance" value={t('offers.alternance')} />}
                {hasEmploiTag && <Tag className="tag-emploi" value={t('offers.job')} />}
                {hasStageTag && <Tag className="tag-stage" value={t('offers.traineeship')} />}
            </div>
        );
    }

    return (
        <>
        {/* <Dialog
            header={<BsInfoCircleFill className="dip-color-tc" />}
            visible={displayIsDisabledStudent}
            style={{ width: '25vw', height: '28vh' }}
            onHide={() => setDisplayIsDisabledStudent(false)}
            className="vue-candidat-dialog"
            footer={
                <div className="dip-flex dip-pc-center">
                    <Button label={t("general.ok")} onClick={() => setDisplayIsDisabledStudent(false)} className="dip-btn-red-bg p-button-rounded" />
                </div>
            }
        >
            <div className="dip-flex dip-ta-center p-mt-5 p-mx-2 dip-fw-500">
                <Trans i18nKey="entreprise.candidate_not_activated" />
            </div>
        </Dialog> */}
            {!loading ? <Helmet>
                <meta charSet="utf-8" />
                <title>{etudiant.prenom} {etudiant.nom.toUpperCase()} - DiplomAdvisor</title>
                <link rel="canonical" href={window.location.href} />
                <meta name="description" content={`Profil de ${etudiant.prenom} ${etudiant.nom.toUpperCase()} - DiplomAdvisor, le 1er moteur de recherche de formations de l'enseignement superieur`} />
            </Helmet> : ''}
            <Toast ref={toast} />
            <Dialog visible={dialogConnection} onHide={() => setDialogConnection(false)} modal={false} style={{ width: '50vw' }}>
                <div className="p-d-flex p-flex-column p-ai-center">
                    <div className="p-mb-3"><Trans i18nKey="login.connection_company_content" /></div>
                    <div className="p-d-flex p-flex-column p-ai-center p-mt-2">
                        <Button label={t('login.log_in')} className="p-button-raised p-button-rounded et-dialog-button" onClick={() => history.push({pathname:"/register?User=Company", state:{candidatUrl: history.location, userType: "Entreprise"}})} />
                    </div>
                </div>
            </Dialog>
            <UpgradeSubscriptionDialog dialogVisible={dialogFreemiumInfo} setDialogVisible={setDialogFreemiumInfo} />
            <MissingCreditsDialog 
                showMissingCreditsPopup={showMissingCreditsPopup} 
                setShowMissingCreditsPopup={setShowMissingCreditsPopup} 
                nextCreditRenewalDate={creditsInfo?.nextRechargeDate}
            />
            {loading ? (
                <div style={{ textAlign: 'center', marginTop: '20%' }}><ProgressSpinner /></div>
            ) : (
                etudiant ? (
                    <>
                        {history.location.state?.offreEmploiId ?
                            <>
                                <EntrepriseOffreBreadCrumb step={2} />
                                <br />
                            </>
                            :
                            history.location.state?.entrepriseId ?
                                <><EntrepriseProfilBreadCrumb step={1} /><br /></>
                                :
                                ''}
                        <div className={`${props.className} p-grid vue-candidat-main-container`.trim()}>
                            {/* Colonne de gauche - Informations personnelles */}
                            <div className="p-col-12 p-sm-12 p-md-12 p-lg-3 p-xl-3 vue-candidat-left-column">
                                {/* Card profil simplifié */}
                                <Card className="p-shadow-3 vue-candidat-profile-card">
                                    {/* Bouton Like en haut à droite */}
                                    {(RoleHelper.isEntreprise(currentUser) || adminImpersonatingRecruteurId) && (
                                        <div className="vue-candidat-like-badge">
                                            <LikeEtudiant etudiant={etudiant} toast={toast} fontSize="1.5rem" />
                                        </div>
                                    )}
                                    <div className="vue-candidat-profile-content">
                                        {/* Avatar */}
                                        <div className="vue-candidat-avatar-container">
                                            {etudiant.fichierPhoto ? (
                                                <div className="vue-candidat-avatar">
                                                    <DisplayProfileImage imageId={etudiant.fichierPhoto.id} />
                                                </div>
                                            ) : (
                                                (() => {
                                                    const first = etudiant?.prenom ? etudiant.prenom.charAt(0) : "";
                                                    const last = etudiant?.nom ? etudiant.nom.charAt(0) : "";
                                                    const initials = (first + last).toUpperCase();
                                                    return (
                                                        <div className="vue-candidat-avatar">
                                                            <Avatar label={initials} />
                                                        </div>
                                                    );
                                                })()
                                            )}
                                        </div>

                                        {/* Nom et titre */}
                                        <div className="vue-candidat-name-section">
                                            <h1 className="vue-candidat-name">{etudiant.prenom} {etudiant.nom.charAt(0).toUpperCase()}</h1>
                                            {etudiant.emploiActuel && (
                                                <p className="vue-candidat-job-title">{etudiant.emploiActuel}</p>
                                            )}
                                        </div>

                                        {/* Informations */}
                                        <div className="vue-candidat-info-section">
                                            {etudiant.niveauEtude && (
                                                <div className="vue-candidat-info-item">
                                                    <IoSchoolOutline className="vue-candidat-info-icon" />
                                                    <span className="vue-candidat-info-value">{etudiant.niveauEtude}</span>
                                                </div>
                                            )}
                                            {(etudiant.commune?.id || (etudiant.lieuResidence && etudiant.pays)) && (
                                                <div className="vue-candidat-info-item">
                                                    <i className="pi pi-map-marker vue-candidat-location-icon"></i>
                                                    <span className="vue-candidat-info-value">
                                                        {etudiant.etranger 
                                                            ? `${etudiant.lieuResidence} (${etudiant.pays})`
                                                            : `${etudiant.commune.libelle} (${etudiant.commune.departement.code})`
                                                        }
                                                    </span>
                                                </div>
                                            )}
                                            {renderMobilite() && (
                                                <div className="vue-candidat-info-item">
                                                    <IoCarOutline className="vue-candidat-info-icon" />
                                                    <span className="vue-candidat-info-value">{renderMobilite()}</span>
                                                </div>
                                            )}

                                            {/* Date à partir de laquelle le candidat est disponible */}
                                            <div className="vue-candidat-info-item">
                                                <IoCalendarOutline className="vue-candidat-info-icon" />
                                                <span className="vue-candidat-info-value">
                                                    {etudiant.rechercheActiveCalendrier
                                                        ? t('company.available_until') + ' ' + Helper.dateTimeToLocaleDateTime(etudiant.rechercheActiveCalendrier)
                                                        : t('general.not_specified')
                                                    }
                                                </span>
                                            </div>
                                        </div>

                                        {/* Documents: CV & Portfolio download (si disponibles) */}
                                        <div className="vue-candidat-documents-section p-mt-2">
                                            {etudiant.fichierCvPdf?.dateValidation && (
                                                <Button label="CV" icon="pi pi-file" className="ct-doc-button p-mr-2" onClick={showCVPdf} />
                                            )}
                                            {etudiant.fichierPortfolio?.dateValidation && (
                                                <Button label="Portfolio" icon="pi pi-briefcase" className="ct-doc-button" onClick={showPortfolio} />
                                            )}
                                        </div>

                                        {/* Boutons d'action - Visible uniquement en tablette/mobile */}
                                        <div className="vue-candidat-actions-mobile">
                                            <div className="vue-candidat-icon-buttons">
                                                {(RoleHelper.isEntreprise(currentUser) || adminImpersonatingRecruteurId) && (
                                                    <>
                                                        <Tooltip target=".projet-overlay-panel-btn-mobile" showDelay={500} position="top" className='dt-df-e-custom-tooltip' content={t("student.tooltip_link_profile_project")} />
                                                        <div className="projet-overlay-panel-btn projet-overlay-panel-btn-mobile">
                                                            <ProjetOverlayPanel className="projet-overlay-panel" etudiantId={etudiant.id} />
                                                        </div>
                                                    </>
                                                )}
                                                {(RoleHelper.isEntreprise(currentUser) || adminImpersonatingRecruteurId) && !loadingEntreprise && (
                                                    <ContactEtudiantDialog 
                                                        etudiant={etudiant} 
                                                        toast={toast} 
                                                        entreprise={entreprise} 
                                                        offreEmploiIntitule={history.location.state?.offreEmploiIntitule} 
                                                        displayFakeInformation={displayFakeInformation} 
                                                        className="vue-candidat-contact-btn" 
                                                        entrepriseId={entreprise?.recruteurEntreprises[0].entrepriseId} 
                                                    />
                                                )}
                                                <Tooltip target=".vue-candidat-share-btn-mobile" showDelay={500} position="top" className='dt-df-e-custom-tooltip' content={t("student.tooltip_share_link")} />
                                                <Button
                                                    icon="pi pi-share-alt"
                                                    className="p-button-rounded dip-btn-red-outline vue-candidat-share-btn vue-candidat-share-btn-mobile"
                                                    onClick={copyUrlLink} 
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                                <br />

                                {/* Recherche d'emploi */}
                                {etudiant.rechercheActive && (
                                    <>
                                        <Card className="p-shadow-3 vue-candidat-card vue-candidat-search-card">
                                            <h3 className="vue-candidat-section-title">{t("student.job_search")}</h3>
                                            <div className="vue-candidat-job-search">
                                                <i className="pi pi-check-circle vue-candidat-check-icon"></i>
                                                <span className="vue-candidat-job-search-text">{t("profile.active_search")}</span>
                                            </div>
                                            {etudiant.paireContrats && etudiant.paireContrats.length > 0 && renderTypeRecherche()}
                                        </Card>
                                        <br />
                                    </>
                                )}
                                {!etudiant.rechercheActive && <br />}

                                {/* Langues */}
                                {etudiant.etudiantLangue && etudiant.etudiantLangue.length > 0 && (
                                    <>
                                        <Card className="p-shadow-3 vue-candidat-card vue-candidat-languages-card">
                                            <h3 className="vue-candidat-section-title">{t('profile.languages')}</h3>
                                            <div className="vue-candidat-languages-list">
                                                {etudiant.etudiantLangue.map((l, indexL) => (
                                                    <div key={`${l.id}~${indexL}`} className="vue-candidat-language-item">
                                                        <span className="vue-candidat-language-name">{l.langue.libelle}</span>
                                                        <span className="vue-candidat-language-level">{l.niveauLangue}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </Card>
                                        <br />
                                    </>
                                )}

                                {/* Emplois recherchés */}
                                {etudiant.rechercheActive && etudiant.etudiantAppellations && etudiant.etudiantAppellations.length > 0 && (
                                    <Card className="p-shadow-3 vue-candidat-card vue-candidat-jobs-card">
                                        <h3 className="vue-candidat-section-title">{t("student.Jobs_targeted")}</h3>
                                        <div 
                                            ref={jobsContentRef}
                                            className={`vue-candidat-jobs-content ${
                                                listeAppellations.length > 4 
                                                    ? (jobsExpanded ? 'vue-candidat-jobs-content-expanded' : 'vue-candidat-jobs-content-collapsed')
                                                    : ''
                                            }`}
                                        >
                                            <div className="vue-candidat-jobs-list">
                                                {listeAppellations.map((appellation, index) => (
                                                    <div key={index} className="vue-candidat-job-item">
                                                        {appellation}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        {!jobsExpanded && listeAppellations.length > 4 && <div className="vue-candidat-jobs-fade-overlay"></div>}
                                        {listeAppellations.length > 4 && (
                                            <div className="vue-candidat-jobs-toggle-container">
                                                <Button 
                                                    label={jobsExpanded ? t('general.see_less') : t('general.see_more')}
                                                    className="vue-candidat-jobs-toggle-btn"
                                                    onClick={handleJobsToggle}
                                                    text
                                                />
                                            </div>
                                        )}
                                    </Card>
                                )}
                            </div>

                            {/* Colonne centrale - Contenu détaillé */}
                            <div className="p-col-12 p-sm-12 p-md-12 p-lg-7 p-xl-7 vue-candidat-center-column">
                                {/* Présentation */}
                                {etudiant.presentation && <><PresentationThumbnail etudiant={etudiant} /><br /></>}
                                
                                {/* Formation */}
                                {(etudiant.formationSuivie.length > 0 || etudiant.formationEnCours.length > 0 || etudiant.formationAVenir.length > 0) && (
                                    <><CursusThumbnail etudiant={etudiant} /><br /></>
                                )}

                                {/* Compétences */}
                                {loadingComptence ? (
                                    <><Card className="p-shadow-5 listelibelle-thumbnail-card" header={<h1 className="vue-candidat-card-title">{t("skills.skills")}</h1>}>
                                        <div style={{ textAlign: 'center' }}><ProgressSpinner /></div>
                                    </Card><br /></>
                                ) : (
                                    etudiant.etudiantCompetences.length > 0 && listeSavoir && listeSavoirFaire && (
                                        <ListeLibelleThumbnail 
                                            title={t("skills.skill")} 
                                            titleplural={t("skills.skills")} 
                                            subTitles={[t("skills.knowledge"), t("skills.expertise")]} 
                                            preview={5} 
                                            tabLibelles={[listeSavoir, listeSavoirFaire]} 
                                            tabCompteurs={[compteurSavoir, compteurSavoirFaire]} 
                                            display="chip" 
                                        />
                                    )
                                )}
                            </div>

                            {/* Colonne de droite - Boutons d'action */}
                            <div className="p-col-12 p-sm-12 p-md-12 p-lg-2 vue-candidat-buttons-column">
                                <div className="vue-candidat-actions-section">
                                    <div className="vue-candidat-icon-buttons">
                                        {(RoleHelper.isEntreprise(currentUser) || adminImpersonatingRecruteurId) && (
                                            <>
                                                <Tooltip target=".projet-overlay-panel-btn" showDelay={500} position="left" className='dt-df-e-custom-tooltip' content={t("student.tooltip_link_profile_project")} />
                                                <div className="projet-overlay-panel-btn">
                                                    <ProjetOverlayPanel className="projet-overlay-panel" etudiantId={etudiant.id} />
                                                </div>
                                            </>
                                        )}
                                        {(RoleHelper.isEntreprise(currentUser) || adminImpersonatingRecruteurId) && !loadingEntreprise && (
                                            <ContactEtudiantDialog 
                                                etudiant={etudiant} 
                                                toast={toast} 
                                                entreprise={entreprise} 
                                                offreEmploiIntitule={history.location.state?.offreEmploiIntitule} 
                                                displayFakeInformation={displayFakeInformation} 
                                                className="vue-candidat-contact-btn" 
                                                entrepriseId={entreprise?.recruteurEntreprises[0].entrepriseId} 
                                            />
                                        )}
                                        <Tooltip target=".vue-candidat-share-btn" showDelay={500} position="left" className='dt-df-e-custom-tooltip' content={t("student.tooltip_share_link")} />
                                        <Button
                                            icon="pi pi-share-alt"
                                            className="p-button-rounded dip-btn-red-outline vue-candidat-share-btn"
                                            onClick={copyUrlLink} 
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <div className="vue-candidat-no-result-container">
                        <Trans i18nKey="student.no_result" />
                    </div>
                )
            )}
        </>
    )
}
